module.exports = __webpack_public_path__ + "static/media/china-flag-icon.f1d49443.svg";